import { createContext, useContext } from 'react';

// types
import type { ReactNode } from 'react';
import type ConfigStore from '@tajawal/web-core-sdk-v2/lib/stores/config.store';

interface ProviderProps {
  config: ConfigStore;
  children: ReactNode;
}

const ConfigContext = createContext<ConfigStore>({} as ConfigStore);

export function ConfigProvider({ config, children }: ProviderProps): JSX.Element {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig(): ConfigStore {
  return useContext<ConfigStore>(ConfigContext);
}

export default ConfigContext;
